import {
  GET_EAADHAAR_LOADING,
  GET_EAADHAAR_SUCCESS,
  GET_EAADHAAR_FAILED,
  GET_EAADHAAR_CAPTCHA_LOADING,
  GET_EAADHAAR_CAPTCHA_SUCCESS,
  GET_EAADHAAR_CAPTCHA_FAILED,
  GET_AADHAAR_LINKED_OTP_LOADING,
  GET_AADHAAR_LINKED_OTP_SUCCESS,
  GET_AADHAAR_LINKED_OTP_FAILED,
  VERIFY_AADHAAR_LINKED_OTP_LOADING,
  VERIFY_AADHAAR_LINKED_OTP_SUCCESS,
  VERIFY_AADHAAR_LINKED_OTP_FAILED,
  SAVE_EAADHAAR_LOADING,
  SAVE_EAADHAAR_SUCCESS,
  SAVE_EAADHAAR_FAILED,
} from "../Constants/eAadhaarConstants";

export const getEAadhaarReducer = (state = { eAadhaarData: {} }, action) => {
  switch (action.type) {
    case GET_EAADHAAR_LOADING:
      return { loading: true, eAadhaarData: {} };
    case GET_EAADHAAR_SUCCESS:
      return { loading: false, eAadhaarData: action.payload };
    case GET_EAADHAAR_FAILED:
      return { loading: false, error: action.eAadhaarData };
    default:
      return state;
  }
};

export const getEAadhaarCaptchaReducer = (
  state = { eAadhaarCaptchaData: {} },
  action
) => {
  switch (action.type) {
    case GET_EAADHAAR_CAPTCHA_LOADING:
      return { loading: true, eAadhaarCaptchaData: {} };
    case GET_EAADHAAR_CAPTCHA_SUCCESS:
      return { loading: false, eAadhaarCaptchaData: action.payload };
    case GET_EAADHAAR_CAPTCHA_FAILED:
      return { loading: false, error: action.eAadhaarCaptchaData };
    default:
      return state;
  }
};

export const getAadhaarLinkedOTPReducer = (
  state = { aadhaarLinkedOTPData: {} },
  action
) => {
  switch (action.type) {
    case GET_AADHAAR_LINKED_OTP_LOADING:
      return { loading: true, aadhaarLinkedOTPData: {} };
    case GET_AADHAAR_LINKED_OTP_SUCCESS:
      return { loading: false, aadhaarLinkedOTPData: action.payload };
    case GET_AADHAAR_LINKED_OTP_FAILED:
      return { loading: false, error: action.aadhaarLinkedOTPData };
    default:
      return state;
  }
};

export const verifyAadhaarLinkedOTPReducer = (
  state = { verifiedAadhaarLinkedOTPData: {} },
  action
) => {
  switch (action.type) {
    case VERIFY_AADHAAR_LINKED_OTP_LOADING:
      return { loading: true, verifiedAadhaarLinkedOTPData: {} };
    case VERIFY_AADHAAR_LINKED_OTP_SUCCESS:
      return { loading: false, verifiedAadhaarLinkedOTPData: action.payload };
    case VERIFY_AADHAAR_LINKED_OTP_FAILED:
      return { loading: false, error: action.verifiedAadhaarLinkedOTPData };
    default:
      return state;
  }
};

export const saveEAadhaarReducer = (
  state = { eAadhaarSavedData: {} },
  action
) => {
  switch (action.type) {
    case SAVE_EAADHAAR_LOADING:
      return { loading: true, eAadhaarSavedData: {} };
    case SAVE_EAADHAAR_SUCCESS:
      return { loading: false, eAadhaarSavedData: action.payload };
    case SAVE_EAADHAAR_FAILED:
      return { loading: false, error: action.eAadhaarSavedData };
    default:
      return state;
  }
};
